import { ApplicationConfig, ErrorHandler, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  provideHttpClient,
  withInterceptors,
  withXsrfConfiguration,
  HttpInterceptorFn,
  withXhr,
} from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { retryInterceptor } from './core/interceptors/retry.interceptor';
import { mockApiInterceptors } from './core/interceptors/mock-api.providers';
import { environment } from '../environments/environment';
import { GlobalErrorHandler } from './core/services/global-error-handler';

// `mockApiInterceptors` is `[]` in production builds (mock-api.providers.prod.ts
// is swapped in via angular.json fileReplacements), so the mock code is dropped
// from the bundle. The runtime flag still guards the `real-api` dev config,
// where the mock module is present but must stay inactive.
//
// Interceptor ordering (outermost to innermost request flow):
//   authInterceptor  — handles 401/403, attaches credentials
//   retryInterceptor — retries transient GET failures before auth sees the error
const httpInterceptors: HttpInterceptorFn[] = [authInterceptor, retryInterceptor];
if (environment.useMockApi) {
  httpInterceptors.push(...mockApiInterceptors);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(
      withXhr(),
      withXsrfConfiguration({
        cookieName: 'XSRF-TOKEN',
        headerName: 'X-XSRF-TOKEN',
      }),
      withInterceptors(httpInterceptors)
    ),
    provideAnimationsAsync(),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
  ],
};
